//ANIMATIONS
const sr = ScrollReveal({
  distance: '60px',
  duration: 1300,
  delay: 150,
  //reset: true
})

sr.reveal(`.itemsDesk .card` , {origin: 'bottom', interval: 100})
sr.reveal(`.itemsMob a` , {origin: 'bottom'})
sr.reveal(`.content` , {origin: 'bottom'})
sr.reveal(`.trin` , {origin: 'right'})